// tslint:disable-next-line: interface-name
interface Window {
  CustomEvent: CustomEvent;
}

/**
 * Polyfil for IE11 not supporting the constructor of CustomEvent
 * Modified to TS from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
 */
(() => {
  if (typeof window.CustomEvent === 'function') {
    return;
  }

  // tslint:disable-next-line: completed-docs
  function CustomEvent<T>(event: string, params?: CustomEventInit<T>): CustomEvent<T> {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    const evt: CustomEvent = document.createEvent('CustomEvent') as any;
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);

    return evt;
  }

  window.CustomEvent = CustomEvent as any;
})();
